export default __webpack_public_path__ + "0dfededfed1116c622a1c498c50692da.png";